import { useNavigate } from "react-router";

/** 404 page — shown when no route matches. */
export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="mx-auto max-w-md text-center">
        <p className="text-6xl">🔍</p>
        <h1 className="mt-4 text-3xl font-bold text-foreground">Page not found</h1>
        <p className="mt-2 text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="rounded-md border border-border px-4 py-2 text-sm text-muted-foreground hover:bg-accent"
          >
            Go back
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
